import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/* import { ValidationProvider } from 'vee-validate';
Vue.component('ValidationProvider', ValidationProvider); */

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import VueMoment from 'vue-moment'

// Bootstrap
import './../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './../node_modules/bootstrap/dist/js/bootstrap.min.js'

import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

//AwesomeFont
//import '../src/utils/font-awesome/css/font-awesome.css'

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'zmdi zmdi-chevron-left',
    next: 'zmdi zmdi-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle'
  }
});

// Fonts
import './../node_modules/roboto-fontface/css/roboto/roboto-fontface.css'
// faltarian los iconos de material que vamos a cambiar a los de bootstrap

// Custom Style
import '../src/assets/scss/my-listview/my-listview.scss'
import '../src/assets/scss/my-form/my-form.scss'
import '../src/assets/scss/my-modal/my-modal.scss'
import '../src/assets/scss/my-app/my-app.scss'
import '../src/assets/scss/my-view-block/my-view-block.scss'
import '../src/assets/scss/my-menu/my-menu.scss'
import '../src/assets/css/app-ecart.css'
//import '../src/assets/css/app-core.css'
//import '../src/assets/js/app-core.js'
//require ('../src/assets/css/app-core.css')
//require ('../src/assets/js/app-core.js')

//sweet alert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import './../node_modules/animate.css/animate.min.css'
import { required } from 'vuelidate/lib/validators'
Vue.use(VueSweetalert2);

// JS
Vue.use(VueMoment)
Vue.use(datePicker)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
